// Heading react component with levels h1 to h6
import React from 'react';
import { cn } from '../../../lib/utils';

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    children: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ level = 1, className, children, ...props }) => {
    const Tag = (`h${level}`) as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

    return (
        <Tag className={cn(`font-semibold`, className)} {...props}>
            {children}
        </Tag>
    );
};

export default Heading;